export const Role = {
    Admin: '1',
    Farmer: '2',
    Worker: '3',
    Digiviewer: '4'     
}